import { useKeyboardShortcut } from '@bestseller-bit/frontend-community.hooks.use-keyboard-shortcut';
import { useCallback } from 'react';

const keyCombo = {
    code: 'KeyC',
    altKey: true,
    description: 'Discard changes',
};
export function useDiscardShortcut(discardChanges: () => void, disabled: boolean) {
    const callback = useCallback(
        (event: KeyboardEvent) => {
            event.preventDefault();
            event.stopPropagation();
            discardChanges();
        },
        [discardChanges]
    );
    useKeyboardShortcut({
        keyCombo,
        callback,
        disabled: disabled,
    });
}
